import axios from "axios";

const BASE_URL = "https://oaouwkt6ue.execute-api.us-east-2.amazonaws.com/prod";

const instance = axios.create({
  baseURL: BASE_URL
});

export default instance;
